import { type Bonus, BonusStage } from '@/api/common';

export type IssuableItem = Pick<Bonus, 'id' | 'stage' | 'createdAt'>;

export const UNSEEN_BONUS_STAGES: readonly BonusStage[] = [
  BonusStage.Issued,
  BonusStage.HandleBets,
];

const isUnseenStage = (stage?: BonusStage): boolean =>
  stage != null && UNSEEN_BONUS_STAGES.includes(stage);

const issuedAtMs = (item: IssuableItem): number =>
  new Date(item.createdAt).getTime();

export const isUnseenBonus = (
  item: IssuableItem,
  lastSeenAt: number | null
): boolean => isUnseenStage(item.stage) && issuedAtMs(item) > (lastSeenAt ?? 0);

export const hasUnseenBonus = (
  items: IssuableItem[] | undefined | null,
  lastSeenAt: number | null
): boolean => !!items?.some((item) => isUnseenBonus(item, lastSeenAt));

export const isNewlyIssuedBonus = (
  incoming: IssuableItem,
  previous?: IssuableItem
): boolean => isUnseenStage(incoming.stage) && !isUnseenStage(previous?.stage);
